import { Instagram, Sparkles } from "lucide-react";

export default function Footer({
  instagramHandle = "tamilperfumeguy_",
  instagramUrl,
  siteName = "tpg.decants",
  tagline,
  settings = {},
}) {
  const defaultTagline = `Curated luxury perfume decants from the shelf of @${instagramHandle}. Smell the world — one decant at a time.`;
  const igHref = instagramUrl || `https://instagram.com/${instagramHandle}`;
  const [left, , right] = siteName.includes(".")
    ? [siteName.split(".")[0], ".", siteName.split(".").slice(1).join(".")]
    : [siteName, "", ""];

  const visitTitle = settings.footer_visit_title || "Visit the Guy";
  const boutiqueTitle = settings.footer_boutique_title || "The Boutique";
  const bullets = [
    settings.footer_bullet_1 || "100% authentic, hand-decanted",
    settings.footer_bullet_2 || "Pay via UPI — GPay / PhonePe",
    settings.footer_bullet_3 || "Orders confirmed via WhatsApp",
    settings.footer_bullet_4 || "Free shipping on orders ₹3000+",
  ].filter((b) => (b || "").trim());
  const marquee = settings.footer_marquee || "Crafted for the fragrance obsessed";

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-[#0A0C11] mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-headings text-2xl uppercase tracking-wide mb-3">
            {right ? (
              <>
                {left}
                <span className="text-[var(--brand-gold)]">.</span>
                {right}
              </>
            ) : (
              left
            )}
          </div>
          <p
            data-testid="footer-tagline"
            className="text-sm text-[var(--text-secondary)] leading-relaxed max-w-xs whitespace-pre-line"
          >
            {tagline || defaultTagline}
          </p>
        </div>

        <div>
          <div
            data-testid="footer-visit-title"
            className="text-xs uppercase tracking-[0.25em] text-[var(--accent-gold)] mb-4"
          >
            {visitTitle}
          </div>
          <a
            href={igHref}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-3 px-5 py-3 border border-[var(--border-default)] hover:border-[var(--brand-gold)] hover:text-[var(--brand-gold)] transition-colors"
          >
            <Instagram size={18} />
            <span className="text-sm tracking-wider">@{instagramHandle}</span>
          </a>
        </div>

        <div>
          <div
            data-testid="footer-boutique-title"
            className="text-xs uppercase tracking-[0.25em] text-[var(--accent-gold)] mb-4"
          >
            {boutiqueTitle}
          </div>
          <ul className="space-y-2 text-sm text-[var(--text-secondary)]">
            {bullets.map((b, i) => (
              <li key={i} className="flex items-center gap-2">
                {i === 0 && <Sparkles size={14} className="text-[var(--brand-gold)]" />}
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-[var(--text-muted)] tracking-wider flex items-center justify-between">
          <span>© {new Date().getFullYear()} {siteName}</span>
          <span data-testid="footer-marquee" className="hidden sm:inline uppercase">{marquee}</span>
        </div>
      </div>
    </footer>
  );
}
